import './Projects.scss';

const arrowSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19px" height="19px" viewBox="0 0 24 24">
    <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 12h16m-7-7l7 7l-7 7" />
  </svg>
);

const Projects = () => {
  return (
    <div className="projects" id='projetos'>
      <h2 className="projects__title">Nossos projetos</h2>
      <div className="projects__list">
        <div className="project-card project-card--impulso">
          <div className="project-card__header">
            <span>Programa<br />Impulso</span>
          </div>
          <h3 className="project-card__subtitle">Empreendedorismo social</h3>
          <p className="project-card__desc">Capacitamos empreendedores a desenvolver soluções inovadoras e sustentáveis para desafios sociais.</p>
          <button className="project-card__button">saiba mais
            {arrowSvg}
          </button>
        </div>
        <div className="project-card project-card--codigo">
          <div className="project-card__header">
            <span>Programa<br />Código livre</span>
          </div>
          <h3 className="project-card__subtitle">Formação para jovens<br />em reclusão social</h3>
          <p className="project-card__desc">Levamos capacitação digital para jovens em situação de reclusão, ampliando suas perspectivas para o futuro.</p>
          <button className="project-card__button">saiba mais
            {arrowSvg}
          </button>
        </div>
        <div className="project-card project-card--zendesk">
          <div className="project-card__header">
            <span>Programa<br />Passaporte Zendesk</span>
          </div>
          <h3 className="project-card__subtitle">Capacitação para imigrantes<br />e refugiados</h3>
          <p className="project-card__desc">Ajudamos refugiados a se inserirem no mercado de trabalho por meio da educação tecnológica.</p>
          <button className="project-card__button">saiba mais
            {arrowSvg}
          </button>
        </div>
        <div className="project-card project-card--lapis">
          <div className="project-card__header">
            <span>Programa<br />Programação à lápis</span>
          </div>
          <h3 className="project-card__subtitle">Formação de professores</h3>
          <p className="project-card__desc">Preparamos educadores para utilizar ferramentas digitais no ensino e ampliar suas metodologias.</p>
          <button className="project-card__button">saiba mais
            {arrowSvg}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Projects
